// extracted by mini-css-extract-plugin
export var drinks = "TM1pyRegistrationFormSingapore-module--drinks--745ac";
export var drinksWrapper = "TM1pyRegistrationFormSingapore-module--drinksWrapper--72b2f";
export var formSubmit = "TM1pyRegistrationFormSingapore-module--formSubmit--27ba0";
export var holder = "TM1pyRegistrationFormSingapore-module--holder--75d90";
export var info = "TM1pyRegistrationFormSingapore-module--info--2a089";
export var location = "TM1pyRegistrationFormSingapore-module--location--9c1a7";
export var main = "TM1pyRegistrationFormSingapore-module--main--127d2";
export var registrationForm = "TM1pyRegistrationFormSingapore-module--registrationForm--6b3d4";
export var registrationFormWrapper = "TM1pyRegistrationFormSingapore-module--registrationFormWrapper--7c406";
export var submit = "TM1pyRegistrationFormSingapore-module--submit--09967";
export var submitRegistrationForm = "TM1pyRegistrationFormSingapore-module--submitRegistrationForm--762b9";
export var thankYouText = "TM1pyRegistrationFormSingapore-module--thankYouText--7dcae";
export var wrapper = "TM1pyRegistrationFormSingapore-module--wrapper--6287a";